import axios from "axios";

/**
 * Setup global axios interceptors for handling authentication errors.
 * This should be called once when the app initializes.
 * 
 * Handles 401 (Unauthorized) and 403 (Forbidden) errors by:
 * - Clearing all authentication data from localStorage
 * - Redirecting to the login page
 */
const setupAxiosInterceptors = () => {
  // Response interceptor for handling auth errors globally
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;

      // Handle authentication errors (401 Unauthorized, 403 Forbidden)
      if (status === 401 || status === 403) {
        console.warn(`Authentication error (${status}): Redirecting to login...`);

        // Clear all authentication data from localStorage
        localStorage.removeItem("token");
        localStorage.removeItem("phone");
        localStorage.removeItem("customer_id");
        localStorage.removeItem("customer_data");
        localStorage.removeItem("us_st_d");

        // Prevent multiple redirects - only redirect if not already on home page
        if (window.location.pathname !== "/") {
          window.location.href = "/";
        }
      }

      return Promise.reject(error);
    }
  );

  // Request interceptor to attach token to all requests
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");

      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );
};

export default setupAxiosInterceptors;
